// extracted by mini-css-extract-plugin
module.exports = {"row":"Two-col-module--row--3w-eR","column":"Two-col-module--column--2nbse","gap":"Two-col-module--gap--2GW5P","inner":"Two-col-module--inner--2kZiO"};